import {Component, Input} from '@angular/core';
import {AbstractControl} from '@angular/forms';

/**
 * The messages for what is wrong with one rendition, shown both under its table row and in the
 * dialog that edits it. A row can turn invalid without being edited (switching the group to
 * two-pass or to a codec without average bitrates), so the table has to say why on its own.
 */
@Component({
  selector: 'app-rendition-errors',
  template: `
    @if (rendition.errors?.vbvWithoutCap) {
      <p class="invalid-feedback d-block">
        Bufsize and min bitrate only act under a max bitrate — clear them, or set a cap.
      </p>
    }
    @if (rendition.errors?.uncappedWithoutTarget) {
      <p class="invalid-feedback d-block">
        @if (twoPass) {
          No max bitrate means an uncapped rung — give it its own average bitrate or CRF.
        } @else {
          No max bitrate means an uncapped rung — give it its own CRF.
        }
        The group's CRF covers capped rungs only: an uncapped rung's own target names its file.
      </p>
    }
    @if (rendition.get('avg_bitrate').errors?.required) {
      <p class="invalid-feedback d-block">
        Two-pass needs an average bitrate on every rendition — none may be left blank
        (or give the rung its own CRF to keep it single-pass).
      </p>
    }
    @if (rendition.get('avg_bitrate').errors?.avgUnsupported) {
      <p class="invalid-feedback d-block">
        {{ codecLabel }} has no average-bitrate mode — target a CRF
        instead; add a max bitrate only when a cap is desired.
      </p>
    }
    @if (rendition.get('crf').errors?.max) {
      <p class="invalid-feedback d-block">
        {{ codecLabel }} accepts CRF 0–{{ crfMax }}; the
        encoder refuses to open above that.
      </p>
    }
    @if (rendition.errors?.crfAndAvg) {
      <p class="invalid-feedback d-block">A rung targets either a CRF or an average bitrate, not both.</p>
    }
  `,
})
export class RenditionErrorsComponent {
  @Input({required: true}) rendition: AbstractControl;
  @Input({required: true}) codecLabel: string;
  @Input({required: true}) twoPass: boolean;
  @Input({required: true}) crfMax: number;
}
